import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetFoodCategoriesListSlice = createSlice({
    name: "getFoodCategoriesList",
    initialState,
    reducers: {
        getFoodCategoriesListRequest(state) {
            state.loading = true;
        },
        getFoodCategoriesListRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getFoodCategoriesListRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getFoodCategoriesListRequest,
    getFoodCategoriesListRequestSuccess,
    getFoodCategoriesListRequestError,
} = GetFoodCategoriesListSlice.actions;

export default GetFoodCategoriesListSlice.reducer;
